import { createApp } from 'vue'
import App from './App.vue'
import store from '../../store_buyfast'
import VueSmoothScroll from 'vue3-smooth-scroll'
import Vue3TouchEvents from "vue3-touch-events";

const app = createApp(App)
app.use(store)
app.use(VueSmoothScroll, {
  duration: 700,
  updateHistory: false
})
app.use(Vue3TouchEvents);
app.config.globalProperties.$gettext = window.gettext;
app.config.globalProperties.$window = window;


app.mount('#buyfast-component')
